import { createStore } from "vuex";

export default createStore({
  state: {},
  mutations: {
    setLoginUser(state, data) {
      state.loginUser = data;
    },
    setLoading(state, data) {
      state.loadingData = data;
    },
  },
  actions: {},
  modules: {},
});
